import React, { Component } from 'react'
import styled from 'styled-components';
import SortButton from './button/SortButton';

class ListTable extends Component {


  render() {
    const { 
      title, 
      totalCount, 
      header, 
      cellWidth, 
      children, 
      sortButton = [], 
      activeSortButton,
      onChangeSort
    } = this.props;
    return (
      <Container>
        <Header>
          <div>
            <strong>
              {title}
            </strong>
            <span>
              총 {totalCount}개
            </span>
          </div>
          <div>
            {
              sortButton?.map((item, index) => (
                <SortButton 
                  key={index} 
                  text={item} 
                  isActive={item === activeSortButton}
                  onClick={() => onChangeSort && onChangeSort(item)}
                />
              ))
            }
          </div>
        </Header>
        <Table>
          <colgroup>
            {
              header?.map((item, index) => (
                <col key={index} width={cellWidth[index]} />
              ))
            }
          </colgroup>
          <thead>
            <tr>
              {
                header?.map((item, index) => (
                  <th key={index}>
                    {item}
                  </th>
                ))
              }
            </tr>
          </thead>
          <tbody>
            {children}
          </tbody>
        </Table>
      </Container>
    );
  }
}
const Container = styled.div`
  width: 100%;

`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 24px;
  margin-bottom: 16px;

  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  & > div > strong {
    font-size: 15px;
    font-weight: 700;
    line-height: 26px;
  }

  & > div > span {
    font-size: 15px;
    font-weight: 400;
    line-height: 26px;
    color: rgba(136, 142, 152, 1);
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  & > thead {
    border-top: 1px solid rgba(75, 81, 91, 1);
  }
  & tr {
    border-bottom: 1px solid rgba(227, 229, 231, 1);
    height: 41px;
    text-align: center;
  }
  & td {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    button {
      text-decoration: none;
      font-size: 12px;
      border-radius: 5px;
      padding: 5px 10px;
      border: none;
    }
    .detail-link {
      background-color: var(--primary-500);
      color: var(--grey-900);
      margin-right: 5px;
    }
    .detail-link:hover {
      background-color: var(--primary-600);
    }
    .edit-link {
      background-color: var(--secondary-500);
      color: var(--white);
    }
    .edit-link:hover {
      background-color: var(--secondary-600);
    }
  }
`;

export default ListTable;